import { settings } from '../../../config/settings';

// AdSense IDs are public, so they live in config/settings.tsx (google_adsense).
// We keep an env-var fallback so existing deployments that still set
// NEXT_PUBLIC_GOOGLE_AD_* continue to work until settings are filled in.
const cfg = (settings as any)?.google_adsense || {};
const enabled = cfg.enabled !== false;

export const ADSENSE_CLIENT: string =
  (enabled ? cfg.client : '') || process.env.NEXT_PUBLIC_GOOGLE_AD_CLIENT || '';

export const ADSENSE_SLOT_SIDE: string =
  (enabled ? cfg.slot_side : '') || process.env.NEXT_PUBLIC_GOOGLE_AD_SLOT_SIDE || '';

export const ADSENSE_SLOT_BOTTOM: string =
  (enabled ? cfg.slot_bottom : '') || process.env.NEXT_PUBLIC_GOOGLE_AD_SLOT_BOTTOM || '';
